<template>
  <QuestionnaireBase :title="title" :form="form" :finishFunction="finishFunction">
    <template v-slot:default>
      <component :is="show" :key="1" :ref="show" v-model="form"/>
      <component
          v-if="load in $options.components"
          v-show="false"
          :is="load"
          key="load"
          :ref="load"
          v-model="form"
      />
    </template>
  </QuestionnaireBase>
</template>

<script>
import {loadHelpers} from "@/views/questionnaires/loadHelpers";
import {dateFormat} from "@/mixins/dateFormat";
import {httpQuestionnaire} from "@/services";

import QuestionnaireBase from "../../../components/common/questionnaires/questionnaire";
import NameStatusAmendment from "@/components/common/questionnaires/fieldsets/amendment/NameStatusAmendment";
import ExecutorsAmendment from "@/components/common/questionnaires/fieldsets/amendment/ExecutorsAmendment";
import TrusteesAmendment from "@/components/common/questionnaires/fieldsets/amendment/TrusteesAmendment";
import BeneficiariesAmendment from "@/components/common/questionnaires/fieldsets/amendment/BeneficiariesAmendment";
import GiftsAmendment from "@/components/common/questionnaires/fieldsets/amendment/GiftsAmendment";
import GuardiansAmendment from "@/components/common/questionnaires/fieldsets/amendment/GuardiansAmendment";
import OtherAmendment from "@/components/common/questionnaires/fieldsets/amendment/OtherAmendment";



export default {
  name: "AmendmentQuestionnaire",
  mixins: [loadHelpers, dateFormat],
  components: {
    QuestionnaireBase,
    NameStatusAmendment,
    ExecutorsAmendment,
    TrusteesAmendment,
    BeneficiariesAmendment,
    GiftsAmendment,
    GuardiansAmendment,
    OtherAmendment,
  },
  data() {
    return {
      name: "AmendmentQuestionnaire",
      title: "Will Amendment Questionnaire",
      url: "amendment_questionnaire",
      save_url: "amendment_data",
      order: [
        "NameStatusAmendment",
        "ExecutorsAmendment",
        "TrusteesAmendment",
        "BeneficiariesAmendment",
        "GuardiansAmendment",
        "GiftsAmendment",
        "OtherAmendment",
      ],
      finishFunction: this.instructionsTaken,
      expiryAccessCodeOnFinish: true

    };
  },
  methods: {
    async instructionsTaken() {
      return httpQuestionnaire
          .post(this.save_url, {
            amendment_id: this.form.id,
            status: "awaiting",
          })
          .then((response) => {
            console.log(response.data);
          })
          .catch((error) => {
            console.log(error);
          });
    }
  }
};
</script>
